export default "__VITE_ASSET__DxpBo4Um__"